export default "__VITE_ASSET__2c84bc78__"